export const DEFAULT_FITMENT_CATALOG_LABEL = "Vehicles";
export const FITMENT_CATALOG_LABEL_CHANGED = "partfinder:fitment-catalog-label-changed";

const storageKey = "partfinder.fitmentCatalog.label";

export const normalizeFitmentCatalogLabel = (value?: string | null) => {
    const label = (value || "").trim();
    return !label || label === "Default fitment catalog" ? DEFAULT_FITMENT_CATALOG_LABEL : label;
};

export const getCachedFitmentCatalogLabel = () => {
    if (typeof window === "undefined") return DEFAULT_FITMENT_CATALOG_LABEL;

    try {
        return normalizeFitmentCatalogLabel(window.localStorage.getItem(storageKey));
    } catch {
        return DEFAULT_FITMENT_CATALOG_LABEL;
    }
};

// First-render labels use this nullable reader so customized catalogs do not
// briefly flash the default label while the settings request is in flight.
export const getStoredFitmentCatalogLabel = () => {
    if (typeof window === "undefined") return null;

    try {
        const value = window.localStorage.getItem(storageKey);
        return value ? normalizeFitmentCatalogLabel(value) : null;
    } catch {
        return null;
    }
};

export const setCachedFitmentCatalogLabel = (value?: string | null) => {
    const label = normalizeFitmentCatalogLabel(value);

    if (typeof window === "undefined") return label;

    try {
        window.localStorage.setItem(storageKey, label);
        window.dispatchEvent(new CustomEvent(FITMENT_CATALOG_LABEL_CHANGED, { detail: label }));
    } catch {
        // Storage can be blocked in embedded browsers; listeners still get the
        // in-memory update so mounted surfaces do not flash stale labels.
        window.dispatchEvent(new CustomEvent(FITMENT_CATALOG_LABEL_CHANGED, { detail: label }));
    }

    return label;
};
